export function validMaxLength(field) {
    return (
        field.value.length <= parseInt(field.getAttribute("data-max-length"))
    );
}
